import * as actionTypes from './actionsTypes';

export const setAddressBookSearchParams = (searchParams) => {
  return {
    type: actionTypes.SETADDRESSBOOKSEARCHPARAMS,
    data: searchParams,
  };
};
